import React, { Fragment, Component } from 'react';
import GenericModal from '../../components/modalGeneric'

export default class queuePendingRefreshComponent extends Component {
    constructor(props){
        super(props);
        this.state = { 
            isModalDisplayed: false,
            modalDetails: null,
            modalTitle: null,
            total: this.props.total || 0,
            items: this.props.items || []
         };
    }
    
    toggleModal = (item, title) => {
        this.setState({
            isModalDisplayed: true,
            modalTitle: item.projectId,
            modalDetails: title
        });
    }
    handleModalClose = (isConfirmed) => {
        this.setState({
            isModalDisplayed: false,
            modalDetails: null,
            modalTitle: null
        });
    }

    componentWillReceiveProps(props) {
        this.setState({
            total: props.total,
            items: props.items || []
        });
    }

    generateTitle = (item, key) => {
        return `ProjectId: ${item.projectId}\nEnqueuedTime: ${item.displayEnqueuedTime}\nCorrelation Id: ${item.correlationId}\nDeliveryCount: ${item.deliveryCount}\nDeadLetterReason: ${item.deadLetterReason || 'N/A'}\nDeadLetterErrorDescription: ${item.deadLetterErrorDescription|| 'N/A'}\nLastUpdated: ${item.lastUpdated|| 'N/A'}`;
    }
    render() {
        const itemDisplaySize = 21;
        var items = this.state.items || [];
        var totalItems = items ? items.length || 0 : 0;
        var remainingItems = 0; 
        var hasManyItems = items && items.length > itemDisplaySize;
        if (hasManyItems){
            items = items.slice(0, itemDisplaySize);
            remainingItems = totalItems - itemDisplaySize;
        }
        var queueEmptyTitle = this.state.total > 0 ? 'No project found' : 'Queue empty'
        var title = this.props.title || '';
        var itemClass = "p-2 pointer-cursor"

        return (
            <div className="card bg-light">
                <div className="card-body p-1">
                <Fragment>
                    <div className="d-flex flex-wrap bd-highlight">
                    <span className={itemClass} key={'queuePendingRefreshTitle_' + title } title={title} > 
                        <b>{title} [{totalItems}/{this.state.total}]: </b>
                    </span>
                    {
                        items == null || items.length <= 0 ?
                        <span className={itemClass} key={'queueEmptyTitle_' + title }>{queueEmptyTitle}</span>
                        :''
                    }
                    {
                        items.map((item, key) => {
                            const title = this.generateTitle(item, key);
                            return (
                                <span className={itemClass} onClick={() => this.toggleModal(item, title)} key={key} title={title} > 
                                    {item.projectId}
                                </span>
                            );
                        })
                    }
                    {hasManyItems === true ? <span className={itemClass}>... ({remainingItems})</span>: ''}
                    </div>
                </Fragment>
                </div>
                
                <GenericModal 
                    isDisplayed={this.state.isModalDisplayed} 
                    handleModalClose={this.handleModalClose}
                    title={this.state.modalTitle}
                    message={this.state.modalDetails} />
            </div>
        )
    }
}